class HelpResources {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/help-resources`;

  }

  async saveHelpResources(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getHelpResourcesByQueryOptions(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async deleteHelpResourceById(resourceId) {

    const path = `${this.basePath}/${resourceId}`;

    return this.apiClient.delete(path, {}, {});

  }

}

export default HelpResources;